import React from "react";

export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hey, I'm Haris</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">Frontend</span> <br />
            Developer
          </h1>
          <p className="hero--section-description">
            crafting responsive websites and dynamic mobile apps
            <br />
            with expertise in React, Next.js, React Native and Angular
          </p>
        </div>
        <button className="btn btn-primary">Get In Touch</button>
      </div>
      <div className="hero--section--img">
        <img src="./img/profile.png" alt="Hero Section" />
      </div>
    </section>
  );
}
